import { render } from "./productManage.vue?vue&type=template&id=1b6cc912&scoped=true"
import script from "./productManage.vue?vue&type=script&lang=js"
export * from "./productManage.vue?vue&type=script&lang=js"

import "./productManage.vue?vue&type=style&index=0&id=1b6cc912&scoped=true&lang=css"
import "./productManage.vue?vue&type=style&index=1&id=1b6cc912&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6cc912"]])

export default __exports__